import React, { Component } from "react";

class TextField extends Component {
  render() {
    const {
      register,
      errors,
      label,
      name,
      rules,
      type,
      className,
      styles,
      labelClassName,
      labelStyles,
    } = this.props;

    // For number inputs, use valueAsNumber to convert to number type
    const registerOptions = type === 'number'
      ? { ...rules, valueAsNumber: true }
      : rules;

    return (
      <>
        <div className={`flex flex-col items-start ${className}`}>
          <label
            htmlFor={`input-${name}`}
            className={`form-label font-bold float-start mb-1 ${labelClassName}`}
            style={labelStyles}
          >
            {rules?.required && <span className="text-red-500">*</span>} {label}
          </label>
          <input
            id={`input-${name}`}
            {...register(name, registerOptions)}
            type={type}
            className="block w-full border border-gray-300 text-gray-900 text-sm  rounded focus:ring-blue-500 focus:border-blue-500  p-1 "
            style={styles}
          />
          {errors[name] && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }
}

export default TextField;
